import styled, { createGlobalStyle } from 'styled-components'

/**
 * Seletor de widgets do dashboard. Mesma linguagem do painel de notificações e
 * dos cartões da home: cabeçalho e rodapé colados nas bordas, hairline
 * #f0f2f5, azul #2c5f9e, tudo em px.
 */

const isLight = (props: any) => props.theme.name === 'light'

/** O .modal-body do globals.ts tem padding de 1rem/2rem, que brigaria com o
 *  cabeçalho e o rodapé encostados nas bordas. */
export const ConfigDashboardModalStyles = createGlobalStyle`
  .widgets-modal .modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(16, 24, 40, 0.24);
    overflow: hidden;
  }
  .widgets-modal .modal-body {
    padding: 0;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  color: #344054;

  .widgets_modal__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 16px 18px;
    border-bottom: 1px solid
      ${p => (isLight(p) ? '#f0f2f5' : 'rgba(255,255,255,.12)')};

    > svg {
      margin: 0;
      font-size: 22px;
      color: #2c5f9e;
    }

    h5 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: ${p => (isLight(p) ? '#101828' : '#fff')};
    }

    small {
      display: block;
      margin-top: 1px;
      font-size: 11.5px;
      font-weight: 400;
      color: #98a2b3;
    }

    > button {
      margin-left: auto;
      display: flex;
      padding: 0;
      border: none;
      background: none;
      color: #98a2b3;
      svg {
        margin: 0;
        font-size: 22px;
      }
      &:hover {
        color: #344054;
      }
    }
  }

  .widgets_modal__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 56vh;
    padding: 14px;
    overflow-y: auto;
  }

  /* A linha inteira alterna o widget — a caixinha sozinha era um alvo de 14px. */
  .widgets_modal__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 13px;
    border: 1px solid ${p => (isLight(p) ? '#eef1f5' : 'rgba(255,255,255,.12)')};
    border-radius: 10px;
    background: none;
    text-align: left;
    transition: background-color 120ms, border-color 120ms;

    > span {
      flex: 1;
      min-width: 0;
      font-size: 13.5px;
      font-weight: 600;
      color: ${p => (isLight(p) ? '#344054' : 'rgba(255,255,255,.75)')};
    }

    &:hover {
      background: ${p => (isLight(p) ? '#f7f9fc' : 'rgba(255,255,255,.06)')};
    }

    &:focus-visible {
      outline: 2px solid #2f5fa0;
      outline-offset: 2px;
    }

    &.is-on {
      border-color: #cfe0f3;
      background: ${p => (isLight(p) ? '#f8fbff' : 'rgba(44,95,158,.18)')};
      > span {
        color: ${p => (isLight(p) ? '#101828' : '#fff')};
      }
      &:hover {
        background: ${p => (isLight(p) ? '#eff5fd' : 'rgba(44,95,158,.26)')};
      }
    }
  }

  .widgets_modal__switch {
    position: relative;
    flex-shrink: 0;
    width: 36px;
    height: 20px;
    border-radius: 999px;
    background: ${p => (isLight(p) ? '#dbe3ec' : 'rgba(255,255,255,.25)')};
    transition: background-color 160ms;

    &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.25);
      transition: transform 160ms;
    }

    &.is-on {
      background: #2c5f9e;
      &::after {
        transform: translateX(16px);
      }
    }
  }

  .widgets_modal__footer {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    border-top: 1px solid
      ${p => (isLight(p) ? '#f0f2f5' : 'rgba(255,255,255,.12)')};
    background: ${p => (isLight(p) ? '#fbfcfd' : 'rgba(255,255,255,.04)')};

    > small {
      flex: 1;
      font-size: 12px;
      color: #98a2b3;
    }

    > button {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 8px 15px;
      border: 1px solid #cfe0f3;
      border-radius: 8px;
      background: ${p => (isLight(p) ? '#fff' : 'rgba(255,255,255,.06)')};
      font-size: 13px;
      font-weight: 700;
      color: #2c5f9e;
      svg {
        margin: 0;
        font-size: 15px;
      }
      &:hover {
        background: ${p => (isLight(p) ? '#f2f7fd' : 'rgba(255,255,255,.12)')};
      }
    }
  }
`
